import React from 'react';
import './VirtualCard.css';

const VirtualCard = ({ card }) => {
  return (
    <div className="virtual-card-container">
      <div className="virtual-card shadow-lg">
        <div className="card-top">
          <span className="card-type">Virtual Card</span>
          <span className="card-chip"></span>
        </div>
        <div className="card-number">
          {card.cardNumber.replace(/\d{4}(?=.)/g, '$& ')}
        </div>
        <div className="card-bottom">
          <div className="card-holder">
            <label>Card Holder</label>
            <div>{card.cardHolderName}</div>
          </div>
          <div className="card-expiry">
            <label>Expires</label>
            <div>{card.expiryDate.substring(0, 2)}/{card.expiryDate.substring(2, 4)}</div>
          </div>
          <div className="card-cvc">
            <label>CVC</label>
            <div>{card.cvc}</div>
          </div>
        </div>
        <div className="card-currency">{card.currency}</div>
      </div>
    </div>
  );
};

export default VirtualCard;
